import React from "react";
import Lottie from "react-lottie";
import * as animationData from "../../assets/lottie/login-lottie.json";

const LoginLottie = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };
  return (
    <Lottie
      style={{ cursor: "default", userSelect: "none" }}
      options={defaultOptions}
      height={350}
      width={350}
    />
  );
};

export default LoginLottie;
